import React from 'react';
import { useFormik } from 'formik';
import { LodgeEnqyiryInitialValues } from '../../../localStore/types';
import { EditEnquiryAutoRenewSchema } from 'utilities/validation/editEnquiryAutoRenew.validation';
import AutoRenewForm from 'components/AutoRenewForm';
import { AutoRenewFormValues } from 'types';

const NewEnquiryAutoRenewForm: React.FC<Props> = ({
  mainValues,
  setMainFieldValue,
  onClose
}) => {
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      autoRenew: mainValues.autoRenew,
      autoRenewEvery: mainValues.autoRenewEvery
        ? Number(mainValues.autoRenewEvery)
        : 3,
      autoRenewUntil: mainValues.autoRenewUntil || '',
      jobEndDate: mainValues.jobEndDate.toString() || ''
    },
    validationSchema: EditEnquiryAutoRenewSchema,
    onSubmit: (values: AutoRenewFormValues) => {
      setMainFieldValue('autoRenew', values.autoRenew);
      setMainFieldValue('autoRenewEvery', values.autoRenewEvery);
      setMainFieldValue('autoRenewUntil', values.autoRenewUntil);
      setMainFieldValue('jobEndDate', values.jobEndDate);
      onClose();
    }
  });

  return (
    <AutoRenewForm
      touched={touched}
      errors={errors}
      values={values}
      enquiryAutoRenewPropertiesData={{
        isEditable: true,
        jobStartAt: mainValues.jobStartDate,
        autoRenew: mainValues.autoRenew,
        autoRenewEvery: mainValues.autoRenewEvery
          ? Number(mainValues.autoRenewEvery)
          : 3,
        autoRenewUntil: mainValues.autoRenewUntil,
        jobEndDate: mainValues.jobEndDate
      }}
      handleSubmit={handleSubmit}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      calendarRef={undefined}
      onClose={() => onClose()}
      hideSummary={true}
      submitLabel="Apply"
      cancelLabel="Back"
    />
  );
};

type Props = {
  mainValues: LodgeEnqyiryInitialValues;
  setMainFieldValue: Function;
  onClose: Function;
};

export default React.memo(NewEnquiryAutoRenewForm);
